import React,{createContext,useCallback,useEffect,useState} from 'react';
import {API_URL} from './config';
export const AuthContext=createContext();
export default function AuthProvider({children}){
    const [isAuthenticated,setIsAuthenticated]=useState(null),[loading,setLoading]=useState(true);
    const refreshAuth=useCallback(async()=>{
        try{const response=await fetch(API_URL+'validate_session.php',{credentials:'include'});if(!response.ok)throw Error('Session unavailable');const session=await response.json();setIsAuthenticated(!!session.loggedIn);return session;}
        catch{setIsAuthenticated(false);return {loggedIn:false};}
        finally{setLoading(false);}
    },[]);
    useEffect(()=>{refreshAuth();},[refreshAuth]);
    return <AuthContext.Provider value={{isAuthenticated,loading,refreshAuth}}>{children}</AuthContext.Provider>;
}
